angular.module('app.facilitadoresdService', [

])

.factory('facilitadoresdService', ['$http', '$q', 'appSettings', function ( $http, $q, appSettings ) {

  return {
    
    getFacilitadoresSexo: function( data ) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/getFacilitadoresSexo')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },
    
    getFacilitadoresSexoDepartamento: function(p_tipo) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+'/getFacilitadoresSexoDepartamento')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
      },

    getFacilitadoresSexoMunicipio: function(p_tipo,p_departamento_iso) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+'/Departamento/'+p_departamento_iso+'/getFacilitadoresSexoMunicipio')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },
      

    getActividadesJueces: function(p_fecha,p_rango) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/getActividadesJueces')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getActividadesJuecesDepartamento: function(p_fecha,p_rango,p_tipo) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Tipo/'+p_tipo+'/getActividadesJuecesDepartamento')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getActividadesJuecesMunicipio: function(p_fecha,p_rango,p_tipo,p_departamento_iso) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Tipo/'+p_tipo+'/Departamento/'+p_departamento_iso+'/getActividadesJuecesMunicipio')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },


    getActividadesFacilitadores: function(p_fecha,p_rango) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/getActividadesFacilitadores')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getActividadesFacilitadoresDepartamento: function(p_fecha,p_rango,p_tipo) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Tipo/'+p_tipo+'/getActividadesFacilitadoresDepartamento')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getActividadesFacilitadoresMunicipio: function(p_fecha,p_rango,p_tipo,p_departamento_iso) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Tipo/'+p_tipo+'/Departamento/'+p_departamento_iso+'/getActividadesFacilitadoresMunicipio')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getParticipantesCharlas: function(p_fecha,p_rango) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/getParticipantesCharlas')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getParticipantesCharlasDepartamento: function(p_fecha,p_rango,p_tipo) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Tipo/'+p_tipo+'/getParticipantesCharlasDepartamento')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getParticipantesCharlasMunicipio: function(p_fecha,p_rango,p_tipo,p_departamento_iso) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Tipo/'+p_tipo+'/Departamento/'+p_departamento_iso+'/getParticipantesCharlasMunicipio')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getCoberturaFJ22: function(p_tipo,p_region,p_departamento_iso,p_fecha,p_fecha_fin,p_id_base_color) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+
                                                              '/Region/'+p_region+
                                                             '/Departamento/'+p_departamento_iso+
                                                            '/Fecha/'+p_fecha+
                                                            '/Fecha_fin/'+p_fecha_fin+
                                                           '/Gama/'+p_id_base_color+
                                                          '/getCoberturaFJ22')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
      },

    getFacilitadoresFJ22: function(p_tipo,p_region,p_departamento_iso,p_fecha,p_fecha_fin,p_id_base_color) {
      var deferred = $q.defer();
      $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+
                                                            '/Region/'+p_region+
                                                           '/Departamento/'+p_departamento_iso+
                                                          '/Fecha/'+p_fecha+
                                                          '/Fecha_fin/'+p_fecha_fin+
                                                         '/Gama/'+p_id_base_color+
                                                        '/getFacilitadoresFJ22')
      .then(successCallback, errorCallback);
          function successCallback(data){
              //success code
              deferred.resolve( data );
          }
          function errorCallback(error){
              //error code
              deferred.reject( error );
          }
      return deferred.promise;
    },

    getActividadesFacilitadores24: function(p_tipo_base,p_tipo,p_region,p_departamento_iso,p_fecha,p_fecha_fin,p_id_base_color) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo_base/'+p_tipo_base+
                                                                    '/Tipo/'+p_tipo+
                                                                  '/Region/'+p_region+
                                                            '/Departamento/'+p_departamento_iso+
                                                                   '/Fecha/'+p_fecha+
                                                               '/Fecha_fin/'+p_fecha_fin+
                                                                    '/Gama/'+p_id_base_color+'/getActividadesFacilitadores24')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    }

}

}]);
